import { memo } from 'react'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useI18n } from 'builder/hooks/useI18n'
import Tooltip from 'builder/components/Tooltip/Tooltip'
import ResumeUploadedIllustration from 'images/builder/fill-resume/upload-success-illustration.png'
import { Div, UploadSuccessIllustration, SuccessTitle, SuccessCaption } from '../styles'

const FileUploadSuccess = () => {
  const { i18n } = useI18n()
  const selectedResume = useTypedSelector(
    state => state.resumeEditor.prefillResumeSection.selectedResume,
  )
  const selectedResumeName = selectedResume?.name

  return (
    <>
      <Div>
        <UploadSuccessIllustration src={ResumeUploadedIllustration} />
      </Div>
      <SuccessTitle>{i18n.t('builder.upload_resume.upload_complete')}</SuccessTitle>
      <Tooltip value={selectedResumeName} multiline>
        <SuccessCaption>{selectedResumeName}</SuccessCaption>
      </Tooltip>
    </>
  )
}

export default memo(FileUploadSuccess)
